import React from 'react'
import { ScreenshotAction, IActionComponentProps } from '~core/forge.type'
import { Box } from '@chakra-ui/react'

interface IProps extends IActionComponentProps {
  action: ScreenshotAction
}

export const ScreenshotActionComponent = ({
  action,
  actions,
  activeActionGesture,
}: IProps) => {
  return (
    <Box width="100%" display="flex" alignItems="center">
      {/* {`Takes a screenshot`} */}
    </Box>
  )
}

export default ScreenshotActionComponent
